@if (content.link) {
  <a [href]="content.link" [target]="content.target">
    @if (content.image) {
      <img
        [ngSrc]="isMobile && content.mobileImage ? content.mobileImage : content.image"
        fill
        priority
        [alt]="content.title"
        (error)="imageError()"
      />
    }
    @if (!content.image) {
      <span>{{ content.title }}</span>
    }
  </a>
}
@if (!content.link) {
  <div>
    @if (content.image) {
      <img
        [ngSrc]="isMobile && content.mobileImage ? content.mobileImage : content.image"
        fill
        priority
        [alt]="content.title"
        (error)="imageError()"
      />
    }
    @if (!content.image) {
      <span>{{ content.title }}</span>
    }
  </div>
}
